export { default as InventarioBodega } from "./InventarioBodega";
